// extracted by mini-css-extract-plugin
export default {"madlibs":"Madlibs_madlibs__cH34A","is-completed":"Madlibs_is-completed__9Cnzz","madlib-wrapper":"Madlibs_madlib-wrapper__kE8xK","madlib-buttons":"Madlibs_madlib-buttons__lI8OA"};